import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_accounts = async () => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/accounts/`,
        method: "GET"
    }))
}

export const create_new_account = async (accountData) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/accounts/`,
        method: "POST",
        body: JSON.stringify(accountData)
    }))
}

export const update_account = async (account_id, accountData) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/accounts/id/${account_id}`,
        method: "PUT",
        body: JSON.stringify(accountData)
    }))
}

export const delete_account = async (account_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/accounts/id/${account_id}`,
        method: "DELETE"
    }))
}

export const fetch_account_by_id = async (account_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/accounts/id/${account_id}`,
        method: "GET"
    }))
}

export const duplicate_account = async (account_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/accounts/duplicate`,
        method: "POST",
        body: JSON.stringify({ account_id })
    }))
}